import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys, helpers } from "@clockwise/web-commons/src/styles/color.styles";

export const disabled: CSSProperties = {
  opacity: 0.4,
  pointerEvents: "none",
};

export const buttonContainer: CSSProperties = {
  display: "flex",
  flexDirection: "row",
};

export const buttonThresholdControls: CSSProperties = {
  width: 427,
};

export const buttonThresholdControl: CSSProperties = {
  borderRadius: 10,
  border: `2px solid ${colors.blueSky.darker}`,
  backgroundColor: helpers.opacity(colors.green.lightest, 0.05),
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  marginBottom: 16,
};

export const buttonThresholdControlInactive: CSSProperties = {
  ...buttonThresholdControl,
  backgroundColor: helpers.opacity(greys.paleGrey, 0.3),
  borderColor: greys.paleGrey,
};

export const buttonControl: CSSProperties = {
  width: 361,
  height: 232,
  marginRight: 20,
  borderRadius: 10,
  border: `2px solid ${colors.blueSky.darker}`,
  backgroundColor: helpers.opacity(colors.green.lightest, 0.05),
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
};

export const buttonControlInactive: CSSProperties = {
  ...buttonControl,
  backgroundColor: helpers.opacity(greys.paleGrey, 0.3),
  borderColor: greys.paleGrey,
};

export const buttonText: CSSProperties = {
  paddingTop: 16,
  paddingLeft: 13,
  color: colors.blueSky.darker,
  display: "flex",
  flexDirection: "row",
  lineHeight: "24px",
};

export const buttonTextInactive: CSSProperties = {
  ...buttonText,
  color: greys.slate,
  fontWeight: "normal",
};

export const buttonThresholdText: CSSProperties = {
  paddingTop: 16,
  paddingBottom: 16,
  paddingLeft: 13,
  color: colors.blueSky.darker,
  display: "flex",
  flexDirection: "row",
  lineHeight: "24px",
  alignItems: "center",
};

export const buttonThresholdTextInactive: CSSProperties = {
  ...buttonThresholdText,
  color: greys.standard,
  fontWeight: "normal",
};

export const buttonIcon: CSSProperties = {
  marginRight: 10,
};

export const buttonIconInactive: CSSProperties = {
  ...buttonIcon,
};

export const buttonImage: CSSProperties = {
  marginTop: "auto",
  paddingTop: 11,
  paddingLeft: 46,
};

export const buttonImageInactive: CSSProperties = {
  ...buttonImage,
  opacity: 0.4,
};

export const buttonThresholdImage: CSSProperties = {
  paddingLeft: 73,
};

export const toggleContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  marginBottom: 15,
};

export const toggleDisabledContainer: CSSProperties = {
  ...toggleContainer,
  ...disabled,
};

export const toggleControl: CSSProperties = {
  marginRight: 10,
};

export const toggleText: CSSProperties = {
  flexGrow: 1,
  color: greys.darkestGrey,
  fontSize: 16,
  marginLeft: 10,
};

export const freeBusyContainer: CSSProperties = {
  width: 310,
  paddingBottom: 16,
};

export const freeBusyDisabledContainer: CSSProperties = {
  ...freeBusyContainer,
  ...disabled,
};

export const remindersContainer: CSSProperties = {
  width: 310,
};

export const remindersDisabledContainer: CSSProperties = {
  ...remindersContainer,
  ...disabled,
};

export const thresholdContainer: CSSProperties = {
  paddingBottom: 20,
};

export const thresholdDisabledContainer: CSSProperties = {
  ...thresholdContainer,
  ...disabled,
};

export const thresholdRadioContainer: CSSProperties = {
  flexDirection: "column",
};

export const thresholdRadioText: CSSProperties = {
  fontSize: 16,
  paddingLeft: 5,
  paddingRight: 20,
};

export const thresholdSelectContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

export const thresholdSelectFormControl: CSSProperties = {};

export const infoIcon: CSSProperties = {
  marginLeft: 4,
  width: 18,
  height: 18,
  color: greys.blueGrey,
};

export const infoIconPopper: CSSProperties = {
  maxWidth: 168,
};

export const typicalText: CSSProperties = {
  fontSize: 14,
  color: greys.slate,
};

export const styles = {
  buttonContainer,
  buttonControl,
  buttonControlInactive,
  buttonText,
  buttonTextInactive,
  buttonIcon,
  buttonIconInactive,
  buttonImage,
  buttonImageInactive,
  buttonThresholdControls,
  buttonThresholdControl,
  buttonThresholdControlInactive,
  buttonThresholdText,
  buttonThresholdTextInactive,
  buttonThresholdImage,
  toggleContainer,
  toggleDisabledContainer,
  toggleControl,
  toggleText,
  freeBusyContainer,
  freeBusyDisabledContainer,
  remindersContainer,
  remindersDisabledContainer,
  thresholdContainer,
  thresholdDisabledContainer,
  thresholdRadioContainer,
  thresholdRadioText,
  thresholdSelectContainer,
  thresholdSelectFormControl,
  infoIcon,
  infoIconPopper,
  typicalText,
};
